/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentoCittadinoDTO } from './documento-cittadino-dto';


export interface DocumentiDaAccettareDTO { 
    da_accettare?: boolean;
    documenti?: Array<DocumentoCittadinoDTO>;
}

